<template>
    <TsColumn append-class="bg-info-dark-border p-6">
            <TsRow appendClass="justify-center">
                <TsImage src="/images/thankyou.webp" width="110" height="110" class="mx-auto" loading="lazy"/>
            </TsRow>
            <TsRow append-class="justify-center">
                <TsTypography align="center" append-class="text-primary" as="h1">{{ props.title }}</TsTypography>
            </TsRow>
            <TsRow append-class="justify-center">
                <TsTypography align="center" append-class="text-primary text-lg">
                    {{ props.para }}
                </TsTypography>
            </TsRow>
        </TsColumn>
</template>

<script setup lang="ts">
    const authStore = useAuthStore();

    const props = defineProps({
        title : String,
        para: String
    });

    // Your application is already submitted.
    //
</script>